/**
 * Client service for Hospital Staff Training & Health-Check Status.
 * R39 C5.a3 (plan docs/plans/sector-operations.md §2 SO-P9, SO-P252, H§5).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'
import type {
  OpsStaffGroup,
  ImmunisationStatus,
  OpsStaffStatusDoc,
  AnnualTrainingStatus,
} from '../types/ops'

export interface SetStaffStatusInput {
  workspaceId: string
  personKey: string
  inductionTrainingOn?: string | null
  lastAnnualTrainingOn?: string | null
  immunisationStatus?: ImmunisationStatus
  healthCheckOn?: string | null
  opId?: string
}

export interface ListStaffStatusInput {
  workspaceId: string
  staffGroup?: OpsStaffGroup
  dueOnly?: boolean
}

export interface StaffStatusItem extends OpsStaffStatusDoc {
  displayName?: string
  staffGroup?: OpsStaffGroup
  trainingStatus: AnnualTrainingStatus
}

export interface GetMyStaffStatusInput {
  workspaceId: string
}

export async function setStaffStatus(
  input: SetStaffStatusInput,
): Promise<{ success: true; statusDocId: string; replayed?: boolean }> {
  return callable<SetStaffStatusInput, { success: true; statusDocId: string; replayed?: boolean }>('setStaffStatus', input)
}

export async function listStaffStatus(
  input: ListStaffStatusInput,
): Promise<{ items: StaffStatusItem[] }> {
  return callable<ListStaffStatusInput, { items: StaffStatusItem[] }>('listStaffStatus', input)
}

export async function getMyStaffStatus(
  input: GetMyStaffStatusInput,
): Promise<{ status: StaffStatusItem | null }> {
  return callable<GetMyStaffStatusInput, { status: StaffStatusItem | null }>('getMyStaffStatus', input)
}
